import { render, staticRenderFns } from "./SmplEditInspChild.vue?vue&type=template&id=70f528aa&scoped=true&"
import script from "./SmplEditInspChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditInspChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f528aa",
  null
  
)

export default component.exports